module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-left panel-reveal theme-dark",
    attrs: {
      "id": "panel-left-menu"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "searchbar row"
  }, [_c('form', {
    staticClass: "js_topSeachForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Products keyword",
      "value": ""
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "category_menu"
  }, [_c('menu-item', {
    attrs: {
      "menuList": _vm.menuList
    },
    on: {
      "update:menuList": function($event) {
        _vm.menuList = $event
      },
      "update:menu-list": function($event) {
        _vm.menuList = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "list-block"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d157871!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Leftmenu.vue
// module id = 257
// module chunks = 1